import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-10" }
const _hoisted_5 = { class: "settings-tabs ps-0 mb-0 list-unstyled" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 mb-40" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-12 mt-20" }
const _hoisted_18 = { class: "buttons-list" }
const _hoisted_19 = {
  type: "button",
  class: "border-0 d-inline-block position-relative text-center transition"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/account-settings",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Account Settings ", -1)
                ])),
                _: 1,
                __: [4]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-statuts",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Status ", -1)
                ])),
                _: 1,
                __: [5]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-type-clients",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Types des clients ", -1)
                ])),
                _: 1,
                __: [6]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-banks",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Liste des banques ", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-social-links",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Lien social ", -1)
                ])),
                _: 1,
                __: [8]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-transports",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Transports ", -1)
                ])),
                _: 1,
                __: [9]
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nom ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newStatut.name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newStatut.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Code ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newStatut.code) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newStatut.code]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Couleur ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "color",
                        class: "form-control shadow-none rounded-0 text-black",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newStatut.code_color) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newStatut.code_color]
                      ])
                    ])
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                      _createElementVNode("button", {
                        class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                        type: "submit",
                        style: {"float":"right"}
                      }, " Save Changes ")
                    ])
                  ], -1))
                ])
              ], 32)
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_17, [
              _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "fs-16 fw-semibold mb-20" }, "Liste des status", -1)),
              _createVNode(_component_EasyDataTable, {
                headers: _ctx.headers,
                items: _ctx.statuts,
                "buttons-pagination": ""
              }, {
                "item-code_color": _withCtx(({ code_color }) => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({
                      width: '40px',
                      height: '20px',
                      backgroundColor: code_color,
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                    })
                  }, null, 4)
                ]),
                "item-actions": _withCtx(({}) => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", _hoisted_19, [
                      _createVNode(_component_font_awesome_icon, { icon: ['far', 'fa-floppy-disk'] })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["headers", "items"])
            ])
          ])
        ])
      ])
    ])
  ]))
}